import { useAuth } from '../../hooks/useAuth';
import { AvatarDisplay } from '../ui/AvatarPicker';

export default function TopRightUser() {
  const { user } = useAuth();

  const roleLabels: Record<string, string> = {
    AO: "Apporteur d'Affaires",
    COMMERCE: 'Collaborateur',
    ADMIN: 'Administrateur',
  };

  // Fallbacks sécurisés
  const displayName = user?.full_name || user?.email || 'Utilisateur';
  const displayRole = user?.role ? (roleLabels[user.role] ?? user.role) : 'Compte';

  return (
    <div className="flex items-center gap-2 md:gap-3">
      <div className="text-right hidden sm:block">
        <div className="text-sm font-medium text-white truncate max-w-[120px] md:max-w-none">{displayName}</div>
        <div className="text-xs text-tp13-muted truncate">{displayRole}</div>
      </div>
      <AvatarDisplay
        avatarId={undefined}
        userName={displayName}
        size="md"
      />
    </div>
  );
}